import { useMutation } from "@tanstack/react-query";

import cookiesHelper from "../../helpers/cookies";

const useSignOut = () => {
    const mutationFn = async () => {
        return { message: "Sign out successful", statusCode: 200 };
    };

    return useMutation({
        mutationFn,
        onSettled: () => {
            cookiesHelper.removeCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string);
            window.location.href = "/auth/sign-in";
        },
    });
};

export default useSignOut;